/**
 * ОТЛОЖИТЬ ДО ПРОСТОЯ (SCRUM-887, третий пункт тикета словами владельца: «значок входящих не на
 * критическом пути (отложить/кешировать)»).
 *
 * ЗАМЕР на стенде владельца, страница райдеров: значок входящих в левом меню зовёт
 * `loadInboxItems()`, тот тянет ТРИ списка — шоу, входящие офферы, свои офферы, — и они уходят
 * РАНЬШЕ списка райдеров (`/offers/incoming` на 1511 мс против `/riders/mine` на 1541). Странице
 * райдеров эти три списка не нужны вовсе; число у значка может появиться секундой позже, а список,
 * за которым человек пришёл, — нет.
 *
 * `requestIdleCallback` есть не везде (Safari до 17 его не знает), поэтому запасной путь — таймер.
 * Никогда не звать — не вариант: значок тогда просто не появится.
 */
interface IdleHost {
  requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
  /** Необязателен: хозяин без своего таймера (и голый объект в тесте) уедет на глобальный. */
  setTimeout?: (handler: () => void, ms: number) => unknown;
}

export function whenIdle(run: () => void, fallbackMs = 1200, host?: IdleHost): void {
  // Хозяин вычисляется ЛЕНИВО и терпит отсутствие `window`: в node-окружении тестов его нет вовсе, и
  // значением по умолчанию здесь стоял `window` — модуль падал на `ReferenceError` у любого, кто
  // поднимал меню в тесте (`side-nav-warehouse.test.ts`).
  const where: IdleHost = host ?? (typeof window !== "undefined" ? window : {});
  const idle = where.requestIdleCallback;
  if (typeof idle === "function") {
    idle.call(where, run, { timeout: fallbackMs });
    return;
  }
  (where.setTimeout ?? globalThis.setTimeout)(run, fallbackMs);
}

/**
 * СПЕРВА ВЫЖДАТЬ, ПОТОМ ДОЖДАТЬСЯ ПРОСТОЯ.
 *
 * Один `requestIdleCallback` эту задачу не решает, и это ИЗМЕРЕНО: 29.10.2026 на стенде владельца
 * значок входящих, отложенный только до простоя, ушёл в сеть на 1111 мс — одновременно со списком
 * райдеров (1101). Простой наступает СРАЗУ, потому что главный поток свободен, пока страница ждёт
 * ответа сервера, а защищаем мы не поток, а СЕРВЕР: он один и однопоточный, и три лишних списка
 * отбирают процессор у того, за который человек ждёт.
 *
 * Поэтому пауза задаётся явно. Секунда выбрана по замеру: `/riders/mine` на тихой машине отвечает
 * за 290–390 мс, под нагрузкой доходило до 865. Число у значка, появившееся секундой позже, человек
 * не замечает; список, которого нет, замечает сразу.
 */
export function whenIdleAfter(delayMs: number, run: () => void, host?: IdleHost): void {
  const where: IdleHost = host ?? (typeof window !== "undefined" ? window : {});
  (where.setTimeout ?? globalThis.setTimeout)(() => whenIdle(run, 1200, host), delayMs);
}
